import { render } from "./ShippingListsDeliveriesTab.vue?vue&type=template&id=45c1f2b4"
import script from "./ShippingListsDeliveriesTab.vue?vue&type=script&lang=js"
export * from "./ShippingListsDeliveriesTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__